import { useEffect, useState } from "react";
import { rehydrateItems, type Item, type ItemDto } from "@/utils/itemclass";

export function useItemList(endpoint: string): { entries: Item[]; isLoading: boolean } {
    const [entries, setEntries] = useState<Item[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function loadEntries() {
            setIsLoading(true);
            const res = await fetch(endpoint);

            if (!res.ok) {
                setEntries([]);
                setIsLoading(false);
                return;
            }

            const raw: ItemDto[] = await res.json();
            setEntries(rehydrateItems(raw));
            setIsLoading(false);
        }

        loadEntries();
    }, [endpoint]);

    return { entries, isLoading };
}
